import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/internal/operators';
import {Document} from '../model/document';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../../config/api-routes';

@Injectable()
export class DocumentsService {

  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) { }

  public getDocuments(): Observable<Document[]> {
    return this.httpClient.get<Document[]>(this.apiRoutes.BUILDING_DOCUMENTS)
      .pipe(
        catchError(error => {
          return of([]);
        })
      );
  }

  public changeDocumentVisibility(application: string, buildingDocumentId: number, visibleForResidents: boolean): Observable<any> {
    return this.httpClient.post(this.apiRoutes.getRouteWithInjectedParams(this.apiRoutes.BUILDING_DOCUMENT_UPDATE_VISIBILITY, [application, buildingDocumentId.toString()]), { visibleForResidents })
      .pipe(
        catchError(error => {
          return of(null);
        })
      );
  }
}
